import type { FC } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "src/components";
import { Routes } from "src/routes";
import { useTranslation } from "src/translations";
import type { DocumentId } from "src/types";

type PayoutPayProps = Readonly<{
    orderDocumentId: DocumentId;
    onPay: () => void;
}>;

export const PayoutPay: FC<PayoutPayProps> = ({ orderDocumentId, onPay }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handlePay = () => {
        onPay();
        navigate(Routes.orderPayInfo.fillPathParams({ orderDocumentId }));
    };

    return (
        <Button onClick={handlePay} className="mx-auto w-full">
            {t("orders.pay.gateway.payout")}
        </Button>
    );
};
